module.exports = __webpack_public_path__ + "static/media/montserrat-extra-bold.3dcf579c.woff2";